import React from 'react';
import { motion } from 'framer-motion';

interface GameControlsProps {
  onDirectionPress: (direction: 'left' | 'right' | 'up' | 'down') => void;
  onDirectionRelease: () => void;
}

const GameControls: React.FC<GameControlsProps> = ({ onDirectionPress, onDirectionRelease }) => {
  return (
    <div className="fixed bottom-0 w-full p-4 flex justify-between pointer-events-none">
      {/* Left side controls */}
      <div className="flex gap-2 pointer-events-auto">
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="w-16 h-16 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center"
          onTouchStart={() => onDirectionPress('left')}
          onTouchEnd={onDirectionRelease}
        >
          ←
        </motion.button>
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="w-16 h-16 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center"
          onTouchStart={() => onDirectionPress('right')}
          onTouchEnd={onDirectionRelease}
        >
          →
        </motion.button>
      </div>

      {/* Right side controls */}
      <div className="flex gap-2 pointer-events-auto">
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="w-16 h-16 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center"
          onTouchStart={() => onDirectionPress('up')}
          onTouchEnd={onDirectionRelease}
        >
          ↑
        </motion.button>
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="w-16 h-16 bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center"
          onTouchStart={() => onDirectionPress('down')}
          onTouchEnd={onDirectionRelease}
        >
          ↓
        </motion.button>
      </div>
    </div>
  );
};

export default GameControls;